/**
 * Une las tarjetas guardadas (GET) con las tarjetas nuevas de la sesión. Si una tarjeta de la sesión
 * ya vino en el GET (mismo token, o mismo BIN y últimos 4 dígitos: backend la guardó tras un pago y
 * el token permanente difiere del token de pago), prevalece la del GET.
 */
import type { SavedCard } from '../domain/models';

const identity = (card: SavedCard): string => `${card.bin}:${card.lastFourDigits}`;

export const mergeCards = (remote: SavedCard[], session: SavedCard[]): SavedCard[] => {
  const remoteTokens = new Set(remote.map((card) => card.token));
  const remoteIdentities = new Set(remote.map(identity));
  return [
    ...remote,
    ...session.filter(
      (card) => !remoteTokens.has(card.token) && !remoteIdentities.has(identity(card)),
    ),
  ];
};
